import { createSlice } from '@reduxjs/toolkit';
import { randomSample , randomizeMSEmoTasks} from '../survey-tools/shuffle-and-sample';

export const taskNames = {
    openScreen: 'open-screen',    
    consent: 'consent',
    micCheck: 'mic-check',
    recallIntro: 'recall-intro',
    recallPos: 'recall-positive',
    recallNeg: 'recall-negative',
    postInductEmotion: 'post-induction-emotion',
    postInductMSInstructions: 'post-induction-mental-state-instructions', 
    postInductValence: 'post-induction-valence', 
    postInductRationality: 'post-induction-rationality', 
    postInductSocImpact: 'post-induction-social-impact', 
    thinkAloud: 'think-aloud',
    postThinkEmotion: 'post-think-emotion',
    postThinkMSInstructions: 'post-think-mental-state-instructions', 
    postThinkValence: 'post-think-valence', 
    postThinkRationality: 'post-think-rationality', 
    postThinkSocImpact: 'post-think-social-impact', 
    AudiosQs: 'audio-qs',
    QuestionnaireInstructions: 'Instructions2',
    SocialInteraction: 'social-interaction',
    CesdDepression: 'cesd-depression',
    UCLALoneliness: 'ucla-loneliness',
    STAI: 'stai',
    Brooding: 'brooding',
    Demographics: 'demographics',
};


const initialState = {
    taskOrder: [
        taskNames.consent,
        taskNames.openScreen,
        taskNames.micCheck,
        taskNames.recallIntro,
        ...randomSample([taskNames.recallPos, taskNames.recallNeg],1),
        ...randomizeMSEmoTasks(taskNames.postInductEmotion,taskNames.postInductMSInstructions, [taskNames.postInductValence,taskNames.postInductRationality,taskNames.postInductSocImpact]),
        taskNames.thinkAloud,
        ...randomizeMSEmoTasks(taskNames.postThinkEmotion,taskNames.postThinkMSInstructions, [taskNames.postThinkValence,taskNames.postThinkRationality,taskNames.postThinkSocImpact]),
        taskNames.AudiosQs,
        taskNames.QuestionnaireInstructions,
        ...randomSample([taskNames.SocialInteraction,taskNames.CesdDepression,taskNames.UCLALoneliness,taskNames.STAI,taskNames.Brooding], 5),
        taskNames.Demographics,
    ],
    currentTask: 0,
    data: {},
    userVars: {}
};

const studySlice = createSlice({
    name: 'study',
    initialState,
    reducers: {
        nextTask: (state, action) => {
            state.currentTask = state.currentTask + 1
            state.data = {...state.data, ...action.payload.data}
            state.userVars = {...state.userVars, ...action.payload.userVars}
        }
    }
})


export const { nextTask } = studySlice.actions;
export default studySlice.reducer;
